module.exports = __webpack_public_path__ + "assets/img/3021.fa3ceb9a.svg";